module.exports = __webpack_public_path__ + "static/media/Animal.c6f659ad.svg";